import { jsx, jsxs } from "react/jsx-runtime";
import { cn } from "../../../utils/cn.js";
import { CdnIcon } from "../../CdnIcon/index.js";
import { IconButton } from "../../IconButton/index.js";
import { Popover } from "../../Popover/index.js";
import { Span } from "../../Text/index.js";
import { overlayTitleVariants } from "./OverlayTitle.variants.js";
function OverlayTitle({ heading, subHeading, backIconName = 'arrow_back', popOverText = '', handleClose, slots = {
    container: '',
    root: '',
    headingClass: '',
    iconClass: '',
    subHeadingClass: ''
} }) {
    const { container, root, headingClass, subHeadingClass, iconClass } = overlayTitleVariants();
    const containerClasses = cn(container(), slots.container);
    const rootClasses = cn(root(), slots.root);
    const headingClasses = cn(headingClass(), slots.headingClass);
    const iconClasses = cn(iconClass(), slots.iconClass);
    const subHeadingClasses = cn(subHeadingClass(), slots.subHeadingClass);
    return /*#__PURE__*/ jsxs("div", {
        className: containerClasses,
        children: [
            /*#__PURE__*/ jsxs("div", {
                className: rootClasses,
                children: [
                    /*#__PURE__*/ jsx("div", {
                        className: "",
                        children: /*#__PURE__*/ jsx(IconButton, {
                            iconName: backIconName,
                            type: "plainPrimary",
                            shadow: true,
                            size: "md",
                            "aria-label": "Close Drawer",
                            onClick: handleClose
                        })
                    }),
                    /*#__PURE__*/ jsx("div", {
                        className: headingClasses,
                        children: /*#__PURE__*/ jsx(Span, {
                            className: "",
                            textStyle: "heading4",
                            children: heading
                        })
                    }),
                    popOverText ? /*#__PURE__*/ jsx("div", {
                        className: iconClasses,
                        "data-testid": "overlay-title-popover-container",
                        children: /*#__PURE__*/ jsx(Popover, {
                            triggerNode: /*#__PURE__*/ jsx(CdnIcon, {
                                palette: "primary",
                                className: "fill-none",
                                iconName: "info",
                                size: "24"
                            }),
                            side: "bottom",
                            children: popOverText
                        })
                    }) : null
                ]
            }),
            subHeading && /*#__PURE__*/ jsx(Span, {
                textStyle: "body1",
                className: subHeadingClasses,
                children: subHeading
            })
        ]
    });
}
export { OverlayTitle };
